import React, { useState } from "react";
import {
  Text,
  TouchableOpacity,
  StyleSheet,
  View,
  Platform,
} from "react-native";

import AppTheme from "../../AppTheme";
import { hasItems } from "../../../../helpers/utils";
import EditReflectionGem from "../../reflection/edit/EditReflectionGem";
import ReportOverallComment from "./ReportOverallComment";

export default function ReportJournalsList({
  controller,
  report = {},
  journals = [],
  hideCommentsIcon = false,
}) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <View style={styles.journals}>
      <ReportOverallComment
        controller={controller}
        report={report}
        hideCommentsIcon={hideCommentsIcon}
      />

      {hasItems(journals) ? (
        <>
          {isCollapsed ? (
            <TouchableOpacity
              style={styles.moreContainer}
              onPress={() => setIsCollapsed(false)}
            >
              <Text style={styles.moreText}>
                {journals.length} more Journals
              </Text>
            </TouchableOpacity>
          ) : null}

          {!isCollapsed
            ? journals.map((journal, index) => (
                <EditReflectionGem
                  item={journal}
                  goal={{}}
                  key={index}
                  inReportMode={true}
                  controller={controller}
                />
              ))
            : null}
        </>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  journals: {
    marginBottom: 8,
    marginTop: 8,
    paddingVertical: 10,
    borderRadius: 4,
    paddingHorizontal: 8,
    backgroundColor: "#FFFFFF",
  },
  moreContainer: {
    height: 34,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 8,
    borderTopColor: AppTheme.borderColor,
    borderTopWidth: 1,
  },
  moreText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: "#768B9D",
  },
});
